import React from "react";
import FormCorrespondanceClasseur from "./FormCorrespondanceClasseur";
import CustomDialog from "../CustomDialog";
import { Classeur } from "../../interfaces";

interface ModalCorrespondanceClasseurProps {
  closeModalCorrespondance: () => void;
  modalIsOpenCorrespondance: boolean;
  openModalAddClasseur: () => void;
  addedClasseur: Classeur;
  setLoading: (newvalue: boolean) => void;
}
const ModalCorrespondanceClasseur = ({
  closeModalCorrespondance,
  modalIsOpenCorrespondance,
  addedClasseur,
  setLoading,
}: ModalCorrespondanceClasseurProps) => {
  return (
    <CustomDialog
      header="Correspondance classeur"
      visible={modalIsOpenCorrespondance}
      closeModalDialog={() => {
        closeModalCorrespondance();
      }}
    >
      <div className="w-full h-full ">
        <div className="p-6 space-y-6">
          <FormCorrespondanceClasseur
            closeModalCorrespondance={closeModalCorrespondance}
            addedClasseur={addedClasseur}
            setLoading={setLoading}
          />
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalCorrespondanceClasseur;
